import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { decodeStorage  } from 'functions/storageBase64'
import { BASE_PATH_PORTAL } from 'constants/general'

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        decodeStorage('session_token')
            ? <Component {...props} />
            : <script>
                {window.console.log(`${BASE_PATH_PORTAL}`)}
                {window.console.log(`${window.location.href}`)}
                {window.console.log(`${BASE_PATH_PORTAL}/login?redirect=${window.location.href}`)}
                {window.location.replace(`${BASE_PATH_PORTAL}/login?redirect=${window.location.href}`) }
                {/*window.location.replace(`${BASE_PATH_PORTAL}/login?redirect=${window.location.href}/prueba`) */}
            </script>
            //: <Redirect to={{ pathname: '/login', state: { from: props.location } }} 
    )} />
)

export default PrivateRoute
